import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { ReactComponent as PositiveYouBackground } from "shared/assets/positive-you/card-background.svg";
import { ReactComponent as CloseCircle } from "@icons/close-circle.svg";
import { ReactComponent as Close } from "shared/assets/Icons/cross.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CardNavButton from "UIPalette/CardNavButton/CardNavButton";
import { ReactComponent as InfoIcon } from "shared/assets/Icons/info-icon.svg";
import { useState } from "react";
import { JournalIntroduction } from "../../../PositiveYou/Components/JournalIntroduction/JournalIntroduction";
import useIsMobile from "shared/core/hooks/useIsMobile";
import { trackBtnClicks } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";

const CloseIcon = () => <Close className="text-brand-purple w-4" />;
const CloseCircleIcon = () => <CloseCircle className="text-brand-purple w-6" />;

export const PositiveYouCard = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "positiveYou" });
  const navigate = useNavigate();
  const [showJournalIntroduction, setShowJournalIntroduction] = useState(false);
  const isMobile = useIsMobile();

  const backIcon = isMobile ? CloseIcon : CloseCircleIcon;

  const handleInfoClick = () => {
    trackBtnClicks(EventNames.POSITIVE_YOU_INFO);
    setShowJournalIntroduction(true);
  };

  return (
    <RoundedCard className="flex flex-col !p-0 overflow-hidden h-72">
      <div className="h-full relative flex flex-col overflow-hidden">
        <div className="h-full relative flex flex-col justify-between p-6">
          <div>
            <div className="flex items-center gap-3">
              <h2>{t("positiveYouNavCard.title")}</h2>
              <InfoIcon className="text-brand-purple -mt-2 z-10" role="button" onClick={handleInfoClick} />
            </div>
            <p>{t("positiveYouNavCard.description")}</p>
          </div>
          <span className="text-xs text-white z-10" dangerouslySetInnerHTML={{ __html: t("accreditation") }}></span>
        </div>
        <PositiveYouBackground className="scale-[1.1] lg:scale-100 absolute z-5 min-h-full min-w-full right-0 top-1/2 -translate-y-1/2 -mt-4" />
      </div>
      <CardNavButton
        label={t("positiveYouNavCard.navLabel")}
        onClick={() => {
          trackBtnClicks(EventNames.POSITIVE_YOU_JOURNAL_CLICK);
          navigate("/positive-you-journal");
        }}
        aria-label={t("positiveYouNavCard.navAriaLabel")}
      />
      {showJournalIntroduction && (
        <JournalIntroduction
          showCta={false}
          backIcon={backIcon}
          backTitle={t("journalForm.close")}
          onClose={() => setShowJournalIntroduction(false)}
        />
      )}
    </RoundedCard>
  );
};
